module.exports = __webpack_public_path__ + "static/kathy-de5e1a7ca4116fed0846f4e7c73141f7.jpg";